
function radiate() {
    let animationTime = 1000;
    document.body.classList.add('radiation');
    requestAnimationFrame(() => {
        document.body.classList.add('radiation-visible');
        setTimeout(() => {
            document.body.classList.remove('radiation-visible');
            setTimeout(() => {
                document.body.classList.remove('radiation');
            }, animationTime);
        }, animationTime);
    });
}

function startContinuousRadiation() {
    document.body.classList.add('radiation');
    requestAnimationFrame(() => {
        document.body.classList.add('radiation-visible');
    });
}

function stopContinuousRadiation() {
    document.body.classList.remove('radiation-visible');
    document.body.classList.remove('radiation');
}

function crackItem(item) {
    let cracksImgs = [
        '/template/images/items_exchanger/crack/1.png',
        '/template/images/items_exchanger/crack/2.png',
        '/template/images/items_exchanger/crack/3.png',
        '/template/images/items_exchanger/crack/4.png',
        '/template/images/items_exchanger/crack/5.png',
        '/template/images/items_exchanger/crack/6.png',
        '/template/images/items_exchanger/crack/7.png',
        '/template/images/items_exchanger/crack/8.png',
        '/template/images/items_exchanger/crack/9.png',
        '/template/images/items_exchanger/crack/10.png'
    ];
    let crackImg = cracksImgs[Math.floor(Math.random()*cracksImgs.length)];
    let angle = Math.floor(Math.random() * (360));
    let shift_x = Math.floor(Math.random() * (41)-20);
    let shift_y = Math.floor(Math.random() * (41)-20);
    item.insertAdjacentHTML('beforeend', `
        <div class="radiated-crack" style="--crack: url('`+crackImg+`'); --angle: `+angle+`deg; --shift-x: `+shift_x+`%; --shift-y: `+shift_y+`%;"></div>
    `);
    // `
    //     <div class="radiated-crack" style="--crack: url(''); --angle: deg; --shift-x: %; --shift-y: %;"></div>
    // `
}

async function crackAndDestroyItem(item) {
    crackItem(item);
    setTimeout(() => {
        crackItem(item);
    }, Math.floor(Math.random() * (300)+150));
    setTimeout(() => {
        crackItem(item);
    }, Math.floor(Math.random() * (300)+450));
    setTimeout(() => {
        crackItem(item);
    }, Math.floor(Math.random() * (300)+750));

    return new Promise (r => {
        setTimeout(() => {
            item.remove();
            r();
        }, Math.floor(Math.random() * (300)+1250));
    });
}

async function crackAndDestroyBetcoin(betcoin) {
    // Add smooth destruction animation for betcoins
    betcoin.style.transition = 'all 0.8s ease-out';
    betcoin.style.transformOrigin = 'center';
    
    // Start with a subtle glow effect
    betcoin.style.boxShadow = '0 0 20px #fba200';
    
    setTimeout(() => {
        // Scale down and fade with rotation
        betcoin.style.transform = 'scale(0.1) rotate(180deg)';
        betcoin.style.opacity = '0';
        betcoin.style.filter = 'blur(3px)';
    }, 100);

    return new Promise(r => {
        setTimeout(() => {
            betcoin.remove();
            r();
        }, 900); // Match transition duration + buffer
    });
}

async function radiateDestroyItems(target = document) {
    target.classList.add('pointer-events-none');
    let promises = [];
    // Destroy both items and betcoins during radiation with appropriate animations
    target.querySelectorAll('.pay__item, .bet-content-coin').forEach(element => {
        if (element.classList.contains('bet-content-coin')) {
            promises.push(crackAndDestroyBetcoin(element));
        } else {
            promises.push(crackAndDestroyItem(element));
        }
    });
    return Promise.all(promises)
        .then(() => {
            target.classList.remove('pointer-events-none');
        });
}

async function revealNewItemAfterRadiation(target, item) {
    let animationLength = 0.350;
    let vibrationLength = 0;//0.150;
    let delay = 0.010;
    if (item.appearLvl == 2) {
        animationLength = 0.500;
        delay = 0.200;
        vibrationLength = 0.500;
    }
    else if (item.appearLvl == 3) {
        animationLength = 1.500;
        delay = 0.500;
        vibrationLength = 1.500;
    }



    let itemEl = document.createElement('div');
    itemEl.classList.add('pay__item');
    itemEl.setAttribute('style', '--animation-length: '+animationLength+'s; color: '+item.color+';')
    itemEl.classList.add('pay__item--appear-after-radiation');
    itemEl.title = item.title;
    itemEl.innerHTML = item.innerHTML;

    target.append(itemEl);

    return new Promise(r => {
        vibrate(5);
        requestAnimationFrame(() => {
            // vibrate(vibrationLength * 1000);
            if (vibrationLength) {
                setTimeout(() => {
                    vibrate(vibrationLength * 1000);
                }, 50);
            }
            setTimeout(() => { //just requestAnimationFrame doesn't help

                itemEl.classList.add('appearing');

                setTimeout(() => {

                    r();
                    itemEl.classList.add('appeared');

                }, animationLength * 1000);

            }, delay * 1000);
        });
    });
}

async function revealNewItemsAfterRadiation(target, items) {
    target.classList.add('pointer-events-none');
    for (let i of items) {
        await revealNewItemAfterRadiation(target, i);
    }
    target.classList.remove('pointer-events-none');
}

async function revealBetcoinAfterRadiation(target, betcoin) {
    let animationLength = 0.500; 
    let vibrationLength = 0.500;
    let delay = 0.010;

    // Create the clean betcoin element with animation styles
    let betcoinEl = document.createElement('div');
    betcoinEl.className = 'bet-content-coin border';
    betcoinEl.innerHTML = betcoin.innerHTML;
    
    // Add animation styles and classes temporarily
    betcoinEl.setAttribute('style', '--animation-length: '+animationLength+'s; color: '+betcoin.color+';')
    betcoinEl.classList.add('pay__item--appear-after-radiation');
    
    target.append(betcoinEl);

    return new Promise(r => {
        vibrate(5);
        requestAnimationFrame(() => {
            if (vibrationLength) {
                setTimeout(() => {
                    vibrate(vibrationLength * 1000);
                }, 50);
            }
            setTimeout(() => {
                betcoinEl.classList.add('appearing');

                setTimeout(() => {
                    // Clean up animation classes and styles
                    betcoinEl.classList.remove('pay__item--appear-after-radiation', 'appearing', 'appeared');
                    betcoinEl.removeAttribute('style');
                    r();
                }, animationLength * 1000);

            }, delay * 1000);
        });
    });
}

function vibrate(val = 5){
    if("vibrate" in navigator) return navigator.vibrate(val);
    if("oVibrate" in navigator) return navigator.oVibrate(val);
    if("mozVibrate" in navigator) return navigator.mozVibrate(val);
    if("webkitVibrate" in navigator) return navigator.webkitVibrate(val);
    return false;
}

// Export animation functions for use in items-reactor.js
export { radiate, startContinuousRadiation, stopContinuousRadiation, radiateDestroyItems, revealNewItemsAfterRadiation, revealNewItemAfterRadiation, revealBetcoinAfterRadiation };
